@if (job) {
  <app-assigned-to [(ngModel)]="job.assigned_to"></app-assigned-to>
  <app-site-visit [job]="job"></app-site-visit>
}
